<template>
<div class="FootballApp">
    <FloatButtomRightPanel/>
    <el-button v-if="false"
               @click="$emit('close')"
    class="drawer-close-button" 
    icon="el-icon-close" 
    circle></el-button>
    <MenuBar v-if="false"></MenuBar>
<!--    <div class="box-img">-->
<!--        <div>-->
<!--            <strong>แทงบอล</strong>-->
<!--            <small>football bet</small>-->
<!--        </div>-->
<!--    </div>-->
    <TableOdd></TableOdd>
    <div class="v-mobile-fixed-bottom-toggle-button">
        <el-button 
        @click="toggleMobileBottomPanel" 
        type="success"
        circle
        >
            <span v-if="my_bet_list_count+bet_list_count" class="icon v-badge" :data-badge="my_bet_list_count+bet_list_count"><i class="fas fa-list"></i></span>
            <span v-if="!(my_bet_list_count+bet_list_count)" class="icon"><i class="fas fa-list"></i></span>
        </el-button>
    </div>
    <div :class="mobileBottomPanelState" class="v-mobile-fixed-bottom">
        <div class="v-mobile-fixed-bottom-inner">
            <div class="flex item-center-vertical" style="justify-content: space-between; height: inherit; padding: 0 10px;">
                <div class="flex">
                    <div :class="{'active': tab1Index === 0}" class="v-mobile-bet-tab" v-on:click="selectTab1(0)">
                        <span>วางเดิมพัน&nbsp;
                            <el-tag v-if="bet_list_count"
                            size="medium"
                            type="danger"
                            effect="dark">
                                {{bet_list_count}}
                            </el-tag>
                        </span>
                    </div>
                    <div :class="{'active': tab1Index === 1}" class="v-mobile-bet-tab" v-on:click="selectTab1(1)">
                        <span>รายการ&nbsp;
                            <el-tag v-if="my_bet_list_count"
                            disable-transitions
                            size="medium"
                            type="danger"
                            effect="dark">
                                {{my_bet_list_count}}
                            </el-tag>
                        </span>
                    </div>
                </div>
                <el-button
                @click="toggleMobileBottomPanel"
                icon="el-icon-arrow-down"
                size="medium"
                type="success"
                plain
                circle>
                </el-button>
            </div>
        </div>
        <div v-show="mobileBottomPanelState === 'expand'" class="v-mobile-bet-panel">
            <BetPanel :modal_bus="modal_bus" v-show="tab1Index === 0" style="width: 100%;"/>
            <MyBet @my_bet_list_count_updated="my_bet_list_count_updated" v-show="tab1Index === 1" ref="MyBet" style="width: 100%;"/>
        </div>
    </div>
    <div v-show="mobileBottomPanelState === 'expand'" @click="close_bottom_panel" class="custom-background-overlay"></div>
    <PleaseWaitModal @cancel="cancelWaitBet" />
    <BetMessageModal @okay="closeBetMessage" @opened="modal_opened" @closed="modal_closed" />
    <FreeBetModal/>
</div>    
</template>
<script>

    import MenuBar from '@/components/MenuBar'
    import TableOdd from './TableOdd'
    import store from '@/store'
    import debounce from '@/debounce'
    import BetPanel from './BetPanel.vue'
    import MyBet from './MyBet.vue'
    import PleaseWaitModal from "./modals/PleaseWaitModal";
    import Vue from "vue";
    import BetMessageModal from "./modals/BetMessageModal";
    import FreeBetModal from './modals/FreeBetModal'
    import FloatButtomRightPanel from '@/components/FloatButtomRightPanel'

export default {
    name: 'FootballApp',
    components: {
        FloatButtomRightPanel,
        TableOdd,
        BetMessageModal,
        PleaseWaitModal,
        BetPanel,
        MyBet,
        FreeBetModal,
        MenuBar,
    },
    data(){
        return {
            mobileBottomPanelState: 'shrink',
            my_bet_list_count: 0,
            modal_bus: new Vue(),
        }
    },
    computed: {
        bet_list_count: function () {
            return store.state.football.bet_list.length;
        },
        tab1Index: function () {
            return store.state.football.tab1Index;
        },
        modal_is_open: function(){
            return store.state.football.modal_is_open;
        },
        modal_code: function(){
            return store.state.football.modal_code;
        },
    },
    watch: {
        bet_list_count: debounce(async function(newVal){
            if(newVal > 0){
                store.commit('football/updateTab1Index', 0);
                this.mobileBottomPanelState = 'expand'
            }else if(!this.modal_is_open){
                this.mobileBottomPanelState = 'shrink'
            }
        }, 100),
        mobileBottomPanelState: function(newVal){
            if(newVal === 'shrink'){
                store.commit('football/updateTab1Index', 0);
            }
        },
        modal_is_open: function(newVal){
            if(!newVal && this.bet_list_count === 0){
                this.mobileBottomPanelState = 'shrink'
            }
            if(newVal){
                document.querySelector('body').classList.add('stop-scrolling');
            }else{
                document.querySelector('body').classList.remove('stop-scrolling');
            }
        },
    },
    methods: {
        selectTab1: function(i){
            if(this.isMobile && i === 1){
                this.mobileBottomPanelState = 'expand'
            }
            store.commit('football/updateTab1Index', i);
        },
        toggleMobileBottomPanel: function(){
            if(this.mobileBottomPanelState === 'shrink'){
                this.mobileBottomPanelState = 'expand'
            }else if(this.mobileBottomPanelState === 'expand'){
                this.mobileBottomPanelState = 'shrink'
            }
        },
        my_bet_list_count_updated: function(val){
            this.my_bet_list_count = val;
        },
        general_modal_closed: function(){
            store.dispatch('clear_modal_info');
        },
        general_okay: function(){
            this.$modal.hide('general');
        },
        general_cancel: function(){
            this.$modal.hide('general');
        },
        close_bottom_panel: function(){
            this.mobileBottomPanelState = 'shrink'
        },
        cancelWaitBet: function(){
            this.modal_bus.$emit('cancelWaitBet');
        },
        closeBetMessage: function () {
            this.modal_bus.$emit('closeBetMessage');
        },
        modal_opened: function(){
            store.commit('football/update_modal_is_open', true);
        },
        modal_closed: function(){
            store.commit('football/update_modal_is_open', false);
        },
    },
    destroyed() {
        this.$emit('destroyed')
    }
}
</script>
<style>
    .FootballApp{
        background-image: linear-gradient(
                135deg
                , #F372D4 10%, #c765f0 100%);
    }
    .FootballApp span.box-txt-back:before{
        content: '\e88a';
        font: 25px "Material Icons";
        margin-right: 5px;
    }
    .FootballApp .box-advertise-game-bottom {
        position: fixed;
        bottom: 80px;
        right: 0;
        align-items: flex-end!important;
    }
    .FootballApp .box-advertise-game-bottom .contentVideoGuide,
    .FootballApp .box-advertise-game-bottom .ChatWithAdmin{
        margin-right: 15px;
    }
    .TableOdd{
        background-color: white;
        height: 100vh;
        overflow-y: scroll;
        border-radius: 20px 20px 0 0;
        z-index: 25;
        position: relative;
    }
    .flex {
        display: flex;
    }

    .flex.justify-center {
        justify-content: center;
    }

    .flex.space-between {
        justify-content: space-between;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .item-center-vertical {
        align-items: center;
    }

    .item-center {
        align-items: center;
        justify-content: center;
    }

    .flex-center-center {
        justify-content: center;
        align-items: center;
    }

    .flex-basis-50 {
        flex-basis: 50px;
    }

    .flex-basis-200 {
        flex-basis: 200px;
    }

    .simple-border {
        border: solid 1px gray;
    }

    .color-white {
        color: white;
    }

    .color-blue {
        color: #005cce;
    }

    .color-blue2 {
        color: #4d93ea;
    }

    .color-red {
        color: red;
    }

    .diy-enter {
        height: 10px;
        width: 100vw;
    }
    .diy-enter.small {
        height: 4px;
    }
    .diy-space {
        width: 10px;
    }
    .diy-space.small {
        width: 4px;
    }
    .balance-text{
        display: none;
        position: absolute;
        top: 15px;
        height: 22px;
        right: 10px;
        border-radius: 10px;
        padding: 1px 8px 1px 15px;
        background-color: rgba(84, 17, 127, 0.7);
        font-size: 13px !important;
        bottom: 0!important;
        margin: 0 0 0 5.5vw!important;
        color: white!important;
    }
    .balance-text:before {
        content: '';
        display: inline-block;
        width: 23px;
        height: 23px;
        position: absolute;
        top: -1px;
        left: -11px;
        background-size: contain;
        background-image: url(data:image/png;base64,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);
        background-repeat: no-repeat;
    }
    .drawer-close-button {
        position: absolute;
        top: 0;
        left: 0;
        background-color: transparent!important;
        border: 0!important;
    }
    .drawer-close-button i{display: none}
    .drawer-close-button:before{
        content: '\e5e0';
        color: white;
        font:  23px "Material Icons";
    }
    .v-mobile-fixed-bottom{
        position: fixed;
        bottom: 0;
        z-index: 999;
        width: 100%;
        overflow-y: auto;
        background-color: white;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        box-shadow: 5px 0 20px #000;
    }
    .v-mobile-fixed-bottom .v-combo-body-one-top span{
        font-size: 1.2em;
    }
    .v-mobile-fixed-bottom.shrink {
        animation: shrink 0.1s ease 1;
        height: 0;
    }
    @keyframes shrink {
        from {
            height: 400px;
        }
        to {
            height: 0;
        }
    }
    .v-mobile-fixed-bottom.expand {
        animation: expand 0.1s ease 1;
        height: 400px;
    }
    @keyframes expand {
        from {
            height: 0;
        }
        to {
            height: 400px;
        }
    }
    .v-mobile-fixed-bottom .v-mobile-fixed-bottom-inner{
        background-color: #363636;
        height: 45px;
        width: 100%;
    }
    .v-mobile-bet-panel {
        display: flex;
        height: 360px;
        width: 100%;
    }
    .v-mobile-bet-tab{
        color: #777;
        cursor: pointer;
        margin-right: 10px;
        padding: 0 15px;
        line-height: 37px;
    }
    .v-mobile-bet-tab.active{
        color: #fff;
        border-bottom: solid 5px #f14668;
    }
    .v-mobile-fixed-bottom-toggle-button {
        position: fixed;
        bottom: 10px;
        right: 10px;
        height: 60px;
        width: 60px;
        background-color: transparent;
        z-index: 1;
    }
    .v-mobile-fixed-bottom-toggle-button button {
        width: 100%;
        height: 100%;
        font-size: 24px;
    }
    .custom-background-overlay {
        position: fixed;
        box-sizing: border-box;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, 0.2);
        z-index: 998;
        opacity: 1;
    }
    .v-badge {
        position:relative;
    }
    .v-badge[data-badge]:after {
        content:attr(data-badge);
        position:absolute;
        top:-4px;
        right:-4px;
        font-size:.7em;
        background: red;
        color:white;
        width:18px;height:18px;
        text-align:center;
        line-height:18px;
        border-radius:50%;
        box-shadow:0 0 1px #333;
    }
    .box-img{
        position: absolute!important;
        top: 7px;
        z-index: 10;
        height: auto!important;
        left: 27px;
    }
    .box-user-img,
    .box-user-img img {
        display: inline-block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .box-img,
    .box-menu-img {
        display: flex;
        color: #fff;
        font-family: "Athiti", sans-serif;
    }

    .box-img {
        padding: 0 15px;
        flex: 3;
        height: unset;
    }

    .box-img small {
        display: block;
        margin-top: -5px;
    }
    @media only screen
    and (min-device-width: 1300px)
    and (orientation: landscape){
        .FootballApp .content-bonus-day,
        .FootballApp .box-alert-content {
            width: 100%;
            height: 100vh;
        }
        .FootballApp .box-freeSpin-content .content-all{
            width: 375px!important;
        }
    }
</style>
<style src="@/assets/css/football.css"></style>